import { CopyIcon, EmailIcon, PhoneIcon } from '@chakra-ui/icons';
import { Button, HStack, IconButton, Text, VStack, useClipboard } from '@chakra-ui/react';
import React, { useMemo } from 'react';

const searchKeyToField = {
  phone_num: 'Telefono',
  client_name: 'nombre',
  id: 'pedido',
};

const parseRequestToText = (request) => `
<strong>Nro. cliente:</strong> ${request.Cliente}<br>
<strong>Nombre:</strong> ${request.nombre}<br>
<strong>Email:</strong> ${request.correo}<br>
<strong>Teléfono:</strong> ${request.Telefono}<br>
<strong>Pedido:</strong> ${request.pedido}<br>
<strong>Tienda:</strong> ${request.Tienda}<br>
<br>
<strong>Dirección entrega:</strong> ${request.direccionentrega}<br>
<strong>Fecha entrega:</strong> ${request.FechaEntrega}<br>
<strong>Hora entrega:</strong> ${request.HoraEntrega}<br>
<br>
<strong>Forma pago:</strong> ${request.FORMAPAGO}<br>
<strong>Tipo entrega:</strong> ${request.TIPOENTREGA}<br>
<br>
<strong>Fecha captura:</strong> ${request.FechaCaptura}<br>
<strong>Hora captura:</strong> ${request.HoraCaptura}<br>
<br>
<strong>Status:</strong> ${request.status}<br>
<strong>Beneficio:</strong> ${request.beneficio}<br>
<strong>Privilegia:</strong> ${request.Privilegia}<br>
<br>
`;

export default function RequestCard({ request, onClickedField }) {
  const requestAsText = useMemo(() => parseRequestToText(request), [request]);
  const { onCopy } = useClipboard(requestAsText, {format: 'text/html'});

  const onFieldClick = (event) => {
    const clickedField = event.target.getAttribute('data-field-key');
    onClickedField(clickedField, request[searchKeyToField[clickedField]]);
  };

  return (
    <HStack borderWidth='1px' boxShadow='sm' justify='space-between' p='2' rounded='md'>
      <VStack align='flex-start'>
        <HStack spacing='8'>
          <Text fontSize='lg' fontWeight='bold'>
            Pedido #{request.pedido}
          </Text>
          <Button
            color='inherit'
            data-field-key='client_name'
            fontSize='lg'
            fontWeight='bold'
            variant='link'
            onClick={onFieldClick}
          >
            {request.nombre}
          </Button>
        </HStack>
        <Button
          color='inherit'
          data-field-key='phone_num'
          fontSize='sm'
          fontWeight='normal'
          variant='link'
          onClick={onFieldClick}
        >
          <PhoneIcon h='4' mr='2' w='4' />
          {request.Telefono}
        </Button>
        <Text fontSize='sm' fontWeight='normal'>
          <EmailIcon h='4' mr='2' w='4' />
          {request.correo}
        </Text>
        <HStack>
          <Text fontSize='sm' fontWeight='normal' maxW='100%'>
            Dirección de entrega:
          </Text>
          <Text fontSize='sm' fontWeight='normal' maxW='100%' opacity='.75'>
            {request.direccionentrega}
          </Text>
        </HStack>
        <HStack>
          <Text fontSize='sm' fontWeight='normal' maxW='100%'>
            Fecha y hora de entrega:
          </Text>
          <Text fontSize='sm' fontWeight='normal' maxW='100%' opacity='.75'>
            {request.FechaEntrega} {request.HoraEntrega}
          </Text>
        </HStack>
      </VStack>
      <IconButton icon={<CopyIcon />} variant='ghost' onClick={onCopy} />
    </HStack>
  );
}
